import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/header";
import AuthService from "./../services/auth.service";

const Changepassword = (props : any) => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isError, setIsError] = useState(true);
    const [forceChangePassword] = useState(AuthService.getCurrentUser().forceChangePassword === "1");
    
    
    function onHandleSubmit(e: React.FormEvent) {
        e.preventDefault();
        setIsError(true);

        var reg = new RegExp('^(?=(.*[a-z]){1,})(?=(.*[A-Z]){1,})(?=(.*[0-9]){1,})(?=(.*[!@#$%^&*()\\-__+.]){1,}).{10,}$');

        if(currentPassword.length === 0) {
            setMessage('Please enter your current password');
        } else if(reg.test(newPassword) === false) {
            setMessage('New password must be at least 10 character long and include one of each, lower case, upper case, special character and a number. ');
        } else if(newPassword !== confirmPassword) {
            setMessage("New and confirm passwords must be same");
        } else {
            setMessage("");
            setLoading(true);
            AuthService.changePassword(currentPassword, newPassword)
                .then((response) => {
                    setIsError(false);
                    setMessage('Password changed successfully');
                    setLoading(false);
                    setSuccess(true);
                    setNewPassword('');
                    setConfirmPassword('');
                    setCurrentPassword('');
                    if (forceChangePassword) AuthService.logout();
                })
                .catch ((error) => {
                    setMessage('Sorry, we are unable to change your password');
                    setLoading(false);
                });
        }
    };

    return (
        <>
            <Header props={props}></Header>
            <div className="row mt-5 justify-content-md-center">
                <div className="col-sm-12 col-md-6 col-lg-4">
                    {forceChangePassword}
                    {message && (
                    <div className="form-group">
                        <div className={`text-${isError ? 'danger' : 'success'}`}>
                        {message}
                        </div>
                    </div>
                    )}
                </div>
            </div>
            <div className="row mt-2 justify-content-md-center">
                <div className="col-sm-12 col-md-6 col-lg-4">
                    <form onSubmit={onHandleSubmit}>
                        <div className="form-group">
                            <label className="form-label fw-bold" htmlFor="username">Current Password</label>
                            <input
                                type="password"
                                className="form-control"
                                name="username"
                                disabled={success}
                                value={currentPassword}
                                onChange={ e => setCurrentPassword(e.currentTarget.value) }
                                required={true}
                            />
                            <div className="invalid-feedback">Please enter your current password</div>
                        </div>
                        <div className="form-group mt-2">
                            <label className="form-label fw-bold" htmlFor="password">New Password</label>
                            <input
                                type="password"
                                className="form-control"
                                name="newPassword"
                                disabled={success}
                                value={newPassword}
                                maxLength={20}
                                onChange={ e => setNewPassword(e.currentTarget.value) }
                                required={true}
                            />
                            <div className="invalid-feedback">Please enter new password</div>
                        </div>
                        <div className="form-group mt-2">
                            <label className="form-label fw-bold" htmlFor="password">Confirm Password</label>
                            <input
                                type="password"
                                className="form-control"
                                name="confirmPassword"
                                disabled={success}
                                value={confirmPassword}
                                maxLength={20}
                                onChange={ e => setConfirmPassword(e.currentTarget.value) }
                                required={true}
                            />
                            <div className="invalid-feedback">Please enter new password</div>
                        </div>
                        <div className="form-group mt-4">
                            { !success &&
                                <button className="btn btn-success btn-block" disabled={loading}>
                                {loading && (
                                    <><span className="spinner-border spinner-border-sm"></span>&nbsp;</>
                                )}
                                <span>Submit</span>
                                </button>
                            }
                            {!forceChangePassword &&
                                <>
                                {!loading &&
                                    <Link className="btn btn-outline-warning float-end me-0" to={`/search`}>Cancel</Link>}
                                {loading &&
                                    <button className="btn btn-outline-warning float-end me-0" disabled={true}>Cancel</button>}
                                </>
                            }

                            {
                            forceChangePassword && success &&
                                <Link className="btn btn-outline-warning float-end me-0" to={`/login`}>Go to Login</Link>
                            }
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}

export default Changepassword;